import { useContext } from "react"
import { NotificationContext } from "@context"
import { GET_MIS_GUARDIAN_EMAILS_XLS_DOWNLOAD } from "@graphql"
import { downloadFile } from "@helpers"
import { Button } from "@heroui/react"
import { useLazyQuery } from "@apollo/client"
import PropTypes from "prop-types"

const GuardianImportIssueReport = ({ backButton, clientId }) => {
  const { notify } = useContext(NotificationContext)

  const [downloadReport, { loading }] = useLazyQuery(GET_MIS_GUARDIAN_EMAILS_XLS_DOWNLOAD, {
    variables: { clientId: clientId },
    fetchPolicy: "no-cache",
    onCompleted: (data) => downloadFile(data.misGuardianEmailsXlsDownload.filename, data.misGuardianEmailsXlsDownload.url),
    onError: () => notify({ title: "Error", type: "danger", content: "There was a problem downloading your report. Please try again.", open: true })
  });

  return (
    <div>
      <p className="mb-6">
        This report highlights guardians that haven't been imported due to multiple guardians sharing the same email address or empty email addresses. Every guardian must have a unique email. This is one reason a student may be missing an associated guardian.
      </p>

      <Button className="font-semibold" color="secondary" fullWidth onPress={() => downloadReport()} isLoading={loading}>Download Report</Button>
      {backButton}
    </div>
  )
}

GuardianImportIssueReport.propTypes = {
  backButton: PropTypes.node.isRequired,
  clientId: PropTypes.string.isRequired,
}

export default GuardianImportIssueReport